/* eslint-disable react/prop-types */
import React from 'react';
import { formatCount, formatShare, statusTheme } from '../utils/theme';
import styles from '../styles/Dashboard.module.css';

const SIZE = 172;
const STROKE = 14;
const GAP = 3;

/** Un estado con suscripciones nunca dibuja un arco tan corto que no se vea. */
const MIN_FRACTION = 0.015;

/**
 * Anillos por estado, como los de actividad de un reloj: cada anillo es la
 * parte del parque en ese estado, de afuera hacia adentro en el orden fijo.
 * La leyenda lleva la cifra exacta, así ningún valor depende solo del arco.
 */
export default function StatusRings({ statuses, total, label }) {
    const center = SIZE / 2;
    const caption = statuses
        .map((item) => {
            const { label: name } = statusTheme(item.status);
            return `${name} ${formatCount(item.total)} (${formatShare(item.total, total)})`;
        })
        .join(', ');

    return (
        <div className={styles.rings}>
            <svg
                className={styles.ringsSvg}
                width={SIZE}
                height={SIZE}
                viewBox={`0 0 ${SIZE} ${SIZE}`}
                role="img"
                aria-label={`${label}: ${caption}`}
            >
                {statuses.map((item, index) => {
                    const radius = center - STROKE / 2 - index * (STROKE + GAP);
                    if (radius < STROKE) return null;
                    const circumference = 2 * Math.PI * radius;
                    const fraction = total ? Math.max(item.total / total, MIN_FRACTION) : 0;
                    const { color } = statusTheme(item.status);
                    return (
                        <g key={item.status} transform={`rotate(-90 ${center} ${center})`}>
                            <circle
                                cx={center}
                                cy={center}
                                r={radius}
                                fill="none"
                                stroke={color}
                                strokeOpacity={0.16}
                                strokeWidth={STROKE}
                            />
                            <circle
                                className={styles.ringArc}
                                cx={center}
                                cy={center}
                                r={radius}
                                fill="none"
                                stroke={color}
                                strokeWidth={STROKE}
                                strokeLinecap="round"
                                strokeDasharray={circumference}
                                strokeDashoffset={circumference * (1 - fraction)}
                                style={{ '--circumference': circumference }}
                            />
                        </g>
                    );
                })}
            </svg>

            <ul className={styles.ringLegend}>
                {statuses.map((item) => {
                    const theme = statusTheme(item.status);
                    return (
                        <li key={item.status}>
                            <span
                                className={styles.swatch}
                                style={{ background: theme.color }}
                            />
                            <span className={styles.ringLabel}>{theme.label}</span>
                            <span className={styles.ringValue}>
                                {formatCount(item.total)}
                                <span className={styles.ringShare}>
                                    {formatShare(item.total, total)}
                                </span>
                            </span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
